import Vue from 'vue'
import configs from '@/config'

let resource = null
const actions = {
  getAllCategories: {
    method: 'GET',
    url: `${configs.api.getCategories}`,
  },
  getCategoryDetail: {
    method: 'GET',
    url: `${configs.api.getCaegoryDetail}{id}`,
  },
}
const initResource = () => {
  resource = Vue.resource('', {}, actions)
}
const getAllCategories = async () => {
  const res = await resource.getAllCategories()
  return res.body
}

const getCategoryDetail = async (id) => {
  const res = await resource.getCategoryDetail({ id })
  return res.body
}

export default {
  initResource,
  getAllCategories,
  getCategoryDetail,
}
